import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import lang from './modules/lang'
import other from './modules/other'
import skills from "./modules/skills";
import review from "./modules/review";
import message from "./modules/message";
import socketio from "./modules/socketio";

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    user,
    lang,
    other,
    skills,
    review,
    message,
    socketio
  },
  strict: false,
})
